import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listOficios:[],
};

export const mutations = {
  GET_OFICIOS({ context }, oficios) {
    let oficios_array = [];
    Object.entries(oficios).forEach(([key, val]) => oficios_array.push(val));
    return (state.listOficios = oficios_array);
  }
};

export const actions = {
  GET_OFICIOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          // commit("SET_LOADING", false);
          commit("GET_OFICIOS", response.data.data.documentos_orden);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_OFICIO({ commit }, oficio) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(oficio)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SAVE_OFICIO", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_FILE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getFile(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_FILES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_ACUSE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getAcuse(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_FILES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_OFICIO({ commit }, oficio) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(oficio)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("DELETE_OFICIO", response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {
  listOficios: state => state.listOficios,
};
